export enum LoginIdType {
  Salesforce = 'user:sfobject',
  ActiveDirectory = 'user:ad',
}
